<form [formGroup]="form" class="flex flex-col justify-center items-start w-full h-full">
  <div class="flex justify-between items-center w-full pr-2 mb-0.5">
    <label
      #subtitleLabel
      for="item"
      [class.text-label]="enabled() && !showInputError()"
      [class.text-label-error]="showInputError()"
      [class.text-label-disabled]="!enabled()"
    >
      {{ configSignal().label }}
      <b class="text-sub-label"> {{ configSignal().subLabel }} </b>
    </label>

    @if (showBlockerIcon()) {
      <app-lock-toggle
        [unlocked]="enabled()"
        (pressed)="toggleEnabled()"
      ></app-lock-toggle>
    }
  </div>

  <div
    #inbox
    class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border bg-white"
    [class.border-blue-700]="enabled() && !showInputError()"
    [class.border-error]="showInputError()"
    [class.border-gray-300]="!enabled()"
  >
    @if (configSignal().type === 'number') {
      <input
        id="item"
        type="text"
        [value]="formattedValue()"
        [readOnly]="!enabled()"
        (input)="onNumberInput($event)"
        (blur)="onBlurInput()"
        class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500"
        [class.bg-gray-100]="!enabled()"
      />
    }
    @else {
      <input
        id="item"
        [type]="configSignal().type"
        formControlName="item"
        [placeholder]="configSignal().placeholder"
        (input)="onUserInput()"
        (blur)="onBlurInput()"
        class="border-none focus:outline-none focus:ring-0 rounded px-3 py-2 w-full h-8 placeholder:text-gray-500"
        [class.bg-gray-100]="!enabled()"
      />
    }
  </div>

  @if (offTimeOut() || (itemControl()?.invalid && itemControl()?.touched)) {

    @if (itemControl()?.hasError('maxDateYesterdayColombia')) {
      <div class="text-red-500 text-[10px] mt-1">
        La fecha no puede ser mayor o igual a hoy.
      </div>
    }

    @else if (itemControl()?.hasError('maxDateTodayColombia')) {
      <div class="text-red-500 text-[10px] mt-1">
        La fecha no puede ser futura.
      </div>
    }

    @else if (itemControl()?.hasError('min')) {
      <div class="text-red-500 text-[10px] mt-1">
        El valor mínimo permitido es {{ itemControl()?.errors?.min?.min }}.
      </div>
    }

    @else if (itemControl()?.hasError('max')) {
      <div class="text-red-500 text-[10px] mt-1">
        El valor máximo permitido es {{ itemControl()?.errors?.max?.max }}.
      </div>
    }

    @else if (hasGenericError() && !hasSpecificError()) {
      <div class="text-red-500 text-[10px] mt-1">
        {{ configSignal().textError }}
      </div>
    }

  }
</form>
